import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ObjectHistory } from '@iotv/datamodel';
import { useMemo, useState } from 'react';
import ObservationCard from '../../cards/Observation/ObservationCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObservationCardWidget = (props) => {
    const [objectHistory] = useState(new ObjectHistory({ type: 'recentStateHistory' }));
    const component = useMemo(() => props.contextCustomer ? (_jsx(ObservationCard, { viewObject: {
            matchedPrimary: props.contextCustomer,
            matchedRelatedByPk: undefined,
            matchedRelatedBySk: undefined,
        }, objectHistory: objectHistory })) : (_jsx(_Fragment, {})), [props.contextCustomer, objectHistory]);
    return {
        name: 'ObservationCard',
        category: 'composite',
        component,
    };
};
